import React, { useEffect, useState } from "react";
import {  useParams } from "react-router-dom";
import { IPriceData } from "../PublicPaymentPage";
import { getPublicQuotationDetails } from "../../api/quotation.api";
import NavBarPSP from "./components/NavbarPSP";
import ThankYouSectionPSP from "./components/ThankYouSectionPSP";
import BookingDetailsSectionPSP from "./components/BookingDetailsSectionPSP";
import PriceBreakupSectionPSP from "./components/PriceBreakupSectionPSP";
import MobileAppSectionPSP from "./components/MobileAppSectionPSP";
import FooterSectionPSP from "./components/FooterSectionPSP";
import "./style.scss";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
// import analytics from "../../utils/googleAnalytics";
interface IData {
  routeName: string;
  portSequence: any[];
  quotationDetails: any;
  bookingDetails: any;
  shipName: string;
}

const PaymentStatusPage: React.FC = () => {
  const [decodedObj, setDecodedObj] = useState<any>({});
  const [loader, setLoader] = useState<boolean>(true);
  const [data, setData] = useState<IData>({ routeName: '', portSequence: [], quotationDetails: {}, bookingDetails: {}, shipName: ''  });
  const [price, setPrice] = useState<any>({ total: 0, cabin_names: [], cabin_fares: [], ssr_names: [], ssr_fares: [], service_tax_and_levies: 0, gst: 0, discount: 0, port_charges: 0, gratuity: 0, fuel_surcharge: 0 });

  const { encodedData } = useParams();

  const decodeBase64Param = (response: string) => {
    const decodedData = atob(response);
    return decodedData;
  };

  const fetchData = async () => {
    if (decodedObj?.quotationId) {
      const data = await getPublicQuotationDetails(decodedObj.quotationId);
      if (data?.status === 200) {
        const { result } = data;
        setData({
          routeName: result?.itinerary?.details?.route,
          portSequence: result?.itinerary?.port_seq,
          quotationDetails: result?.quotation,
          bookingDetails: result?.booking,
          shipName: result?.itinerary?.details?.ship_name
        });
        calculatePrice(result?.pricing);
        setLoader(false);
      } else console.error(data?.response?.data?.message);
    }
  };

  useEffect(() => {
    if (encodedData) {
      const jsondecodedObj = JSON.parse(decodeBase64Param(encodedData));
      setDecodedObj(jsondecodedObj);
    }
  }, [encodedData]);

  useEffect(() => { fetchData(); }, [decodedObj]);

  const calculatePrice = (priceObj: any[]) => {
    let tempObj: IPriceData = { total: 0, cabin_names: [], cabin_fares: [], ssr_names: [], ssr_fares: [], service_tax_and_levies: 0, gst: 0, discount_category: {}, discount: 0, port_charges: 0, gratuity: 0, fuel_surcharge: 0 };
    priceObj?.forEach((value: any) => {
      const discountCategoryObject = value?.discount_category?.reduce((acc: any, discountName: string) => {
        acc[discountName] = true;
        return acc;
      }, {});
      if (value.type === "CABIN") {
        tempObj = {
          ...tempObj,
          total: tempObj.total + value.cabin_fare + value.service_tax_and_levies + value.gst + value.fuel_surcharge,
          cabin_names: [...tempObj.cabin_names, value.title],
          cabin_fares: [...tempObj.cabin_fares, value.cabin_fare],
          service_tax_and_levies:
            tempObj.service_tax_and_levies + value.service_tax_and_levies,
          gst: tempObj.gst + value.gst,
          discount_category: { ...tempObj.discount_category, ...discountCategoryObject },
          discount: tempObj.discount + value.discount,
          port_charges: tempObj.port_charges + value.port_charges,
          fuel_surcharge: tempObj.fuel_surcharge + value.fuel_surcharge,
          gratuity: tempObj.gratuity + value.gratuity
        };
      } else {
        tempObj = {
          ...tempObj,
          total: tempObj.total + value.total + value.service_tax_and_levies + value.gst + value.fuel_surcharge,
          ssr_names: [...tempObj.ssr_names, value.title],
          ssr_fares: [...tempObj.ssr_fares, value.total],
          service_tax_and_levies:
            tempObj.service_tax_and_levies + value.service_tax_and_levies,
          gst: tempObj.gst + value.gst,
          discount_category: { ...tempObj.discount_category, ...discountCategoryObject },
          discount: tempObj.discount + value.discount,
          port_charges: tempObj.port_charges + value.port_charges,
          fuel_surcharge: tempObj.fuel_surcharge + value.fuel_surcharge,
          gratuity: tempObj.gratuity + value.gratuity
        };
      }
    });
    setPrice({ ...tempObj });
  };

  return (
    <>
      {loader ?
        <FullPageLoader /> : 
        <div className="payment-status-wrapper">
          <NavBarPSP />
          <ThankYouSectionPSP status={decodedObj?.status === "success"} currency={decodedObj?.order?.currency} totalAmount={decodedObj?.order?.total_amount} />
          <div className="booking-info-parent-wrapper-psp">
            <BookingDetailsSectionPSP bookingNumber={data?.bookingDetails?.number} quotationNumber={data?.quotationDetails?.number} routeName={data?.routeName} portSequence={data?.portSequence} roomsData={data?.quotationDetails?.items} night={data?.quotationDetails?.nights} shipName={data?.shipName}/>
            <PriceBreakupSectionPSP priceData={price} discountDescription={data?.quotationDetails?.offerDescriptions} bookingData={data?.bookingDetails} tcsSlab={data?.quotationDetails?.quotationTcs?.[0]?.tcsSlab || 0} />
          </div>
          <MobileAppSectionPSP/>
          <FooterSectionPSP/>
        </div>}
    </>
  );
}; 

export default PaymentStatusPage;
